let ios: boolean | undefined;

function isIOS() {
  if (ios === undefined) {
    ios =
      /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document); // iOS 13 detection
  }
  return ios;
}

// Replace Input type='search' to support autocomplete='off' for all browsers
// except iOS mobile to prevent keypad action from being marked as 'Search'.
export function getInputTypeForAutoCompleteOff(type: string): string {
  const isIOSDevice = isIOS();
  if ((type === 'text' || type === 'tel') && !isIOSDevice) {
    return 'search';
  }
  return type;
}
